import React, { useState } from "react";
import * as bootstrap from "bootstrap";
import "../App.css";

import Swal from "sweetalert2";

import { FormCampista } from "./forms/FormCampista";
import { ModalPago } from "./ModalPago";
import { ModalConfirmacionPago } from "./ModalConfirmacionPago";

import campista from "../assets/campista.jpeg";

export const ModalRegistroMiembro = ({ show, onClose }) => {
  //=========================================
  // ESTADOS
  //=========================================

  const [loading, setLoading] = useState(false);

  const [mensajeError, setMensajeError] = useState("");

  //=========================================
  // MODAL PAGO
  //=========================================

  const [mostrarPago, setMostrarPago] = useState(false);

  //=========================================
  // MODAL CONFIRMACIÓN
  //=========================================

  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);

  //=========================================
  // DATOS PARA MODAL PAGO
  //=========================================

  const [datosPago, setDatosPago] = useState({
    nombre: "",

    documento: "",
  });

  //=========================================
  // GOOGLE APPS SCRIPT
  //=========================================

  const GOOGLE_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzzCx-aBFZRPS8LDLll2GZcd-DOcwfPeGTB_kDGn9fVAbwjm5ZBgEjKaIB3G5WTMGcd/exec";

  //=========================================
  // FORMULARIO
  //=========================================

  const [form, setForm] = useState({
    tipo: "campista",

    nombre: "",

    apellido: "",

    celular: "",

    tipo_celular: "",

    documento: "",

    pais: "",

    departamento: "",

    iglesia: "",

    edad: "",

    proyecto: "",

    estadoCivil: "",

    hijos: "",

    especialidad: "",

    comentario: "",

    especialidades: [],
  });

  //=========================================
  // ACTUALIZAR INPUTS
  //=========================================

  const handleChange = (e) => {
    setForm({
      ...form,

      [e.target.name]: e.target.value,
    });

    setMensajeError("");
  };

  //=========================================
  // CERRAR MODAL REGISTRO
  //=========================================

  const cerrarModalBootstrap = () => {
    const modalElement = document.getElementById("registroMiembroModal");

    const modalInstance = bootstrap.Modal.getInstance(modalElement);

    if (modalInstance) {
      modalInstance.hide();
    }

    setTimeout(() => {
      document.body.classList.remove("modal-open");

      document.body.style.removeProperty("overflow");

      document.body.style.removeProperty("padding-right");

      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());

      onClose();
    }, 300);
  };

  //=========================================
  // VALIDAR FORMULARIO
  //=========================================

  const validarFormulario = () => {
    const camposObligatorios = [
      "nombre",

      "apellido",

      "celular",

      "tipo_celular",

      "documento",

      "pais",

      "departamento",

      "iglesia",

      "edad",

      "proyecto",
    ];

    for (const campo of camposObligatorios) {
      if (!form[campo] || form[campo].toString().trim() === "") {
        setMensajeError("Debe completar todos los campos obligatorios.");

        return false;
      }
    }

    //=======================================
    // VALIDAR CELULAR
    //=======================================

    if (!/^[0-9]{9,15}$/.test(form.celular)) {
      setMensajeError("Ingrese un número de celular válido.");

      return false;
    }

    //=======================================
    // VALIDAR EDAD
    //=======================================

    if (Number(form.edad) < 13 || Number(form.edad) > 99) {
      setMensajeError("Ingrese una edad válida.");

      return false;
    }

    setMensajeError("");

    return true;
  };

  //=========================================
  // ENVIAR REGISTRO
  //=========================================

  const enviarFormulario = async (e) => {
    e.preventDefault();

    //=====================================
    // VALIDAR
    //=====================================

    if (!validarFormulario()) {
      return;
    }

    setLoading(true);

    try {
      //===================================
      // GUARDAR REGISTRO
      //===================================

      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",

        mode: "no-cors",

        headers: {
          "Content-Type": "text/plain",
        },

        body: JSON.stringify({
          accion: "registro",

          ...form,

          tipo: "campista",
        }),
      });

      //===================================
      // GUARDAR DATOS PARA PAGO
      //===================================

      setDatosPago({
        nombre: `${form.nombre} ${form.apellido}`,

        documento: form.documento,
      });

      //===================================
      // CERRAR MODAL REGISTRO
      //===================================

      const modalElement = document.getElementById("registroMiembroModal");

      const modalInstance = bootstrap.Modal.getInstance(modalElement);

      if (modalInstance) {
        modalInstance.hide();
      }

      //===================================
      // LIMPIAR BACKDROP
      //===================================

      setTimeout(() => {
        document.body.classList.remove("modal-open");

        document.body.style.removeProperty("overflow");

        document.body.style.removeProperty("padding-right");

        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());

        //=================================
        // ABRIR MODAL PAGO
        //=================================

        setMostrarPago(true);
      }, 300);

      //===================================
      // LIMPIAR FORMULARIO
      //===================================

      setForm({
        tipo: "campista",

        nombre: "",

        apellido: "",

        celular: "",

        tipo_celular: "",

        documento: "",

        pais: "",

        departamento: "",

        iglesia: "",

        edad: "",

        proyecto: "",

        estadoCivil: "",

        hijos: "",

        especialidad: "",

        comentario: "",

        especialidades: [],
      });

      setMensajeError("");
    } catch (error) {
      console.error("Error al enviar el formulario:", error);

      Swal.fire({
        icon: "error",

        title: "Ups...",

        text: "No fue posible enviar el formulario.",

        confirmButtonColor: "#9b2a92",
      });
    } finally {
      setLoading(false);
    }
  };

  //=========================================
  // SI NO ESTÁ ACTIVO
  //=========================================

  if (!show) {
    return null;
  }

  return (
    <>
      {/*=====================================
        MODAL REGISTRO MIEMBRO
      =====================================*/}

      <div
        className="modal fade show"
        id="registroMiembroModal"
        tabIndex="-1"
        style={{
          display: "block",

          background: "rgba(0,0,0,.6)",
        }}
      >
        <div
          className="
            modal-dialog
            modal-fullscreen-md-down
            modal-xl
            modal-dialog-centered
            modal-dialog-scrollable
          "
        >
          <div
            className="
              modal-content
              border-0
              shadow-lg
            "
            style={{
              borderRadius: "25px",

              overflow: "hidden",
            }}
          >
            {/*=================================
              HEADER
            =================================*/}

            <div
              className="
                text-white
                p-4
              "
              style={{
                background: "linear-gradient(135deg,#44296a 0%,#370a33 100%)",
              }}
            >
              <div
                className="
                  d-flex
                  flex-column
                  flex-md-row
                  justify-content-between
                  align-items-start
                  align-items-md-center
                "
              >
                <div>
                  <h3 className="fw-bold mb-1">¡PARTICIPA!</h3>

                  <p className="mb-0 opacity-75">
                    Completa tus datos para participar en esta experiencia
                    misionera.
                  </p>
                </div>

                <button
                  type="button"
                  className="
                    btn-close
                    btn-close-white
                  "
                  onClick={cerrarModalBootstrap}
                />
              </div>
            </div>

            {/*=================================
              BODY
            =================================*/}

            <div
              className="modal-body"
              style={{
                padding: "clamp(1rem,3vw,2rem)",
              }}
            >
              {/*=================================
                TARJETA MIEMBROS
              =================================*/}

              <div className="miembro-card">
                <img
                  src={campista}
                  alt="Miembros"
                  className="
                    miembro-card-img
                  "
                />

                <div
                  className="
                    miembro-card-overlay
                  "
                >
                  <span
                    className="
                      miembro-card-texto
                    "
                  >
                    MIEMBROS
                  </span>
                </div>
              </div>

              <br />

              {/*=================================
                FORMULARIO
              =================================*/}

              <form onSubmit={enviarFormulario}>
                <FormCampista form={form} handleChange={handleChange} />

                {/*=================================
                  ERROR
                =================================*/}

                {mensajeError && (
                  <div
                    className="
                      alert
                      alert-danger
                      rounded-4
                      text-center
                      fw-semibold
                      mt-4
                    "
                  >
                    {mensajeError}
                  </div>
                )}

                {/*=================================
                  BOTÓN GUARDAR
                =================================*/}

                <div
                  className="
                    d-flex
                    justify-content-center
                    align-items-center
                    mt-5
                  "
                >
                  <button
                    type="submit"
                    disabled={loading}
                    className="
                      btn
                      text-white
                      rounded-pill
                      px-5
                      py-3
                    "
                    style={{
                      background: "linear-gradient(135deg,#9b2a92,#3d1042)",

                      border: "none",

                      minWidth: "240px",
                    }}
                  >
                    {loading ? "Enviando..." : "Guardar Registro"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/*=====================================
        MODAL PAGO
      =====================================*/}

      <ModalPago
        show={mostrarPago}
        datos={datosPago}
        onClose={() => {
          setMostrarPago(false);
        }}
        onPagoRegistrado={() => {
          //=================================
          // CERRAR MODAL PAGO
          //=================================

          setMostrarPago(false);

          //=================================
          // ABRIR CONFIRMACIÓN
          //=================================

          setTimeout(() => {
            setMostrarConfirmacion(true);
          }, 400);
        }}
      />

      {/*=====================================
        MODAL CONFIRMACIÓN DE PAGO
      =====================================*/}

      <ModalConfirmacionPago
        show={mostrarConfirmacion}
        onClose={() => {
          setMostrarConfirmacion(false);

          //=================================
          // CERRAR TODO
          //=================================

          onClose();

          //=================================
          // RECARGAR
          //=================================

          setTimeout(() => {
            window.location.reload();
          }, 300);
        }}
      />
    </>
  );
};

export default ModalRegistroMiembro;
